import { Navbar } from "../components/Navbar";
import { Hero } from "../components/Hero";
import { CountryGrid } from "../components/CountryGrid";
import { FeatureStrip } from "../components/FeatureStrip";
import { Footer } from "../components/Footer";
import { Seo, organizationLd, websiteLd, faqLd, breadcrumbLd } from "../components/Seo";

export default function Landing() {
  // Landing-page FAQ schema — these target the highest-volume Indian travel queries
  // and earn Google's FAQ rich snippet directly on SERP.
  const landingFaqs = faqLd([
    {
      question: "Is Flycher really a free AI travel planner?",
      answer:
        "Yes — Flycher is 100% free. The AI itinerary generator, AI trip planner, visa wizard, INR budget calculator, forex center, reality check, and phrasebook are all free with no signup wall, credit card, or subscription. We earn from affiliate partners when you book through our recommended links.",
    },
    {
      question: "What is the best free AI travel planner for India?",
      answer:
        "Flycher is built specifically for Indian travelers — it prices everything in INR, knows visa rules for Indian passport holders, recommends Indian forex cards (Niyo, Wise), and accounts for departure from Indian airports. Unlike generic AI trip planners, every output is India-relevant.",
    },
    {
      question: "How does the AI trip planner / AI itinerary generator work?",
      answer:
        "Pick a country, dates, travel style, interests, and food preferences. The AI itinerary generator (powered by Claude) creates a day-by-day plan with stays, activities, food picks, and approximate INR pricing. You can edit, save, share, or export to PDF — all free.",
    },
    {
      question: "Can the AI itinerary generator handle 10+ day trips?",
      answer:
        "Yes. The AI trip planner uses parallel chunking to generate long itineraries (10, 14, 21+ days) without timing out — each chunk is generated concurrently and stitched into a single day-by-day plan.",
    },
    {
      question: "Which countries does the AI travel planner support?",
      answer:
        "Vietnam, Thailand, Bali (Indonesia), Japan, Maldives, Oman, Malaysia, Singapore, Sri Lanka, Nepal, Philippines, Laos — plus UAE, Turkey, Schengen Europe, UK, USA, Australia, and South Korea for visa, forex, and phrasebook tools. More destinations are added regularly.",
    },
    {
      question: "Is the trip budget calculation accurate?",
      answer:
        "It pulls real round-trip flight base fares from your nearest Indian airport via TravelPayouts, then layers AI-calibrated estimates for stays, food, activities, local transport, and visa fees based on your travel style (budget / balanced / luxury) and traveler count.",
    },
    {
      question: "Can I share or download my AI-generated itinerary?",
      answer:
        "Yes. Every itinerary generated by the AI trip planner has a public shareable link and a colorful one-click PDF export — perfect for sharing with travel companions, attaching to visa applications, or carrying offline.",
    },
    {
      question: "Do I need an account to use the AI planner?",
      answer:
        "No. You can generate AI itineraries, check visas, calculate budgets, and use every tool without signing up. Optionally sign in with Google to save your trips and travel notes across devices.",
    },
  ]);

  const breadcrumbs = breadcrumbLd([{ name: "Home", path: "/" }]);

  return (
    <main data-testid="landing-page" className="relative pb-mobile-nav">
      <Seo
        title="Free AI Travel Planner, AI Trip Planner & AI Itinerary Generator · India"
        description="Free AI travel planner, AI trip planner & AI itinerary generator built for Indians. Generate day-by-day AI itineraries, check visa & budget in INR, compare forex cards, get a destination reality check — all free. Vietnam, Thailand, Bali, Japan, Maldives & more."
        path="/"
        jsonLd={[organizationLd(), websiteLd(), landingFaqs, breadcrumbs]}
      />
      <Navbar />
      <Hero />
      <CountryGrid />
      <FeatureStrip />
      <Footer />
    </main>
  );
}
